module.exports = __webpack_public_path__ + "pc/img/ai01.08c9ec32.png";